<template>
  <footer class="footer bg-dark text-light py-4 mt-auto">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12 text-center">
          <div class="footer-links mb-3">
            <router-link
              to="/privacy-policy"
              class="footer-link text-muted me-4"
            >
              {{ $t("footer.privacyPolicy") }}
            </router-link>
            <router-link to="/terms-conditions" class="footer-link text-muted">
              {{ $t("footer.termsConditions") }}
            </router-link>
          </div>
          <div class="footer-copyright">
            <small class="text-secondary">
              © {{ currentYear }} {{ appName }}.
              {{ $t("footer.allRightsReserved") }}
            </small>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script setup>
import { computed, getCurrentInstance } from "vue";

// Get current year
const currentYear = computed(() => new Date().getFullYear());

// Get app name from environment or use default
const appName = computed(() => {
  const instance = getCurrentInstance();
  return (
    instance?.appContext.config.globalProperties.$env?.VUE_APP_NAME ||
    "PastryCalc"
  );
});
</script>

<style scoped>
.footer {
  margin-top: auto;
  width: 100%;
}

.footer-link {
  text-decoration: none;
  transition: color 0.3s ease;
}

.footer-link:hover {
  color: #198754 !important;
  text-decoration: none;
}

.footer-links {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  gap: 1rem;
}

@media (max-width: 576px) {
  .footer-links {
    flex-direction: column;
    gap: 0.5rem;
  }
}
</style>
